var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.19 2.13818H7.81C4.17 2.13818 2 4.30818 2 7.94818V16.3182C2 19.9682 4.17 22.1382 7.81 22.1382H16.18C19.82 22.1382 21.99 19.9682 21.99 16.3282V7.94818C22 4.30818 19.83 2.13818 16.19 2.13818ZM13.79 15.1382C14.08 15.4282 14.08 15.9082 13.79 16.1982C13.64 16.3482 13.45 16.4182 13.26 16.4182C13.07 16.4182 12.88 16.3482 12.73 16.1982L9.2 12.6682C8.91 12.3782 8.91 11.8982 9.2 11.6082L12.73 8.07818C13.02 7.78818 13.5 7.78818 13.79 8.07818C14.08 8.36818 14.08 8.84818 13.79 9.13818L10.79 12.1382L13.79 15.1382Z",
    fill: "#000014"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.82f22c3db041a5f35c1caa6c79e517b5.svg";
export { ForwardRef as ReactComponent };